import { render } from "./CustomerPageBar.vue?vue&type=template&id=b774fb42"
import script from "./CustomerPageBar.vue?vue&type=script&lang=js"
export * from "./CustomerPageBar.vue?vue&type=script&lang=js"

import "./CustomerPageBar.vue?vue&type=style&index=0&id=b774fb42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__